import BaseIcon from './BaseIcon';

export default BaseIcon;
